<script lang="ts">
  import { Compass } from 'lucide-svelte';
  import { push } from 'svelte-spa-router';
  import { Button } from '$lib/components/ui/button';
  import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '$lib/components/ui/card';
</script>

<main class="bg-background grid min-h-screen place-items-center px-4">
  <Card class="w-full max-w-md text-center">
    <CardHeader>
      <div
        class="bg-primary/10 text-primary mx-auto mb-2 flex size-12 items-center justify-center rounded-full"
      >
        <Compass class="size-6" />
      </div>
      <CardTitle class="text-2xl">404</CardTitle>
      <CardDescription>This route doesn't exist.</CardDescription>
    </CardHeader>
    <CardContent>
      <Button variant="outline" onclick={() => push('/dashboard')}>Back to dashboard</Button>
    </CardContent>
  </Card>
</main>
